module.exports = __webpack_public_path__ + "static/media/C015.4de2423f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/carousel/C015.jpg
// module id = 298
// module chunks = 0